import { render, staticRenderFns } from "./addAdmin.vue?vue&type=template&id=25904de8&"
import script from "./addAdmin.vue?vue&type=script&lang=js&"
export * from "./addAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25904de8')) {
      api.createRecord('25904de8', component.options)
    } else {
      api.reload('25904de8', component.options)
    }
    module.hot.accept("./addAdmin.vue?vue&type=template&id=25904de8&", function () {
      api.rerender('25904de8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commission/user/addAdmin.vue"
export default component.exports